import React from 'react';
import '../styles/Loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="transaction-loader">
        <div className="zebra-path" />
      </div>
      <p className="not-found-text">Loading ...</p>
    </div>
  );
};

export default Loader;
